import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState, useEffect } from "react";
import Banner from '@/components/PageBanner';
import ContactForm from '@/components/ContactForm';
// @ts-ignore
import cookieCutter from 'cookie-cutter'

export default function ScienceAndData({pageContent, researchPapers, siteSettings}:any) {
  // Need to check cookies to see if registered.  If not show the /registration link, otherwise jsut download link
  const [needsToRegister, setNeedsToRegister] = useState(true);

  // check for the show/hide banner cookie on page load
  function checkCookieStatus(event:any) {
    // Get a cookie
    const isRegistered = cookieCutter.get('losRegistrationStatus');
    if (isRegistered === '1') {
      setNeedsToRegister(false);
    }
  }

  useEffect(() => {
    // @ts-ignore
    checkCookieStatus();
  });

  return (
    <>
      <Head>
        <title>The Line of Sight &#8480;</title>
      </Head>
      <Nav />
      <main className="row science-row">
        <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
        <div className="col-12">
          <div className="container">
            <div className="row rp-overview-row">
              <div className="col-12 rp-overview-col">
                <div className="overview-text regular-font" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].overview_text)}}>
                  {/* */}
                </div>
                <hr />
              </div>
            </div>
            <div className="row">
              {researchPapers.map((paper:any) => (
                <div id={`${paper._id}`} key={`${paper._id}`} className="col-12 rp-col">
                  <div className="content">
                    <div className="row research-paper-row">
                      <div className="col-12 col-sm-2 research-paper-img-col">
                        <img src={urlFor(paper.paper_thumbnail).width(400).url()} />
                      </div>
                      <div className="col-12 col-sm-10 research-paper-details-col">
                        <div className="title title-font">{paper.title}</div>
                        <div className="abstract regular-font" dangerouslySetInnerHTML={{__html: toHTML(paper.abstract)}}>
                          {/* */}
                        </div>
                        {needsToRegister ?
                          <a href={`/registration/?research_paper=${paper._id}`} className="btn download-btn purple-btn">DOWNLOAD</a>
                        :
                          <a id={`paper-${paper._id}`} type='application/pdf' href={`https://cdn.sanity.io/files/26sxkmoh/production/${paper.document.asset._ref.replace('file-','').replace('-pdf','.pdf')}?dl=${paper.document.asset._ref.replace('file-','').replace('-pdf','.pdf')}`} className="btn download-btn purple-btn" download>DOWNLOAD</a>
                        }
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              ))}
            </div>
          </div>
        </div>
        <ContactForm adminEmails={siteSettings[0].admin_emails} />
      </main>
      <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "scienceAndDataPage"]`);
  const researchPapers = await client.fetch(groq`*[_type == "researchPaper"] | order(sort_order asc)`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      researchPapers: researchPapers,
      siteSettings: siteSettings
    }
  }
}
